import { useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { CalendarCheck, Search, Check } from "lucide-react";

export default function DailyReportingFix() {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async (apply) => {
    if (apply && !window.confirm("Marcar essas semanas como reportadas e recalcular os pontos?")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/fix-daily-reporting", { apply });
      setR(data);
      if (apply) toast.success(`${data.count} semanas corrigidas`);
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };

  return (
    <div className="kw-card p-6 space-y-4" data-testid="daily-reporting-fix">
      <div className="flex items-center gap-2">
        <CalendarCheck className="w-5 h-5 text-[#E50000]" />
        <h3 className="font-display text-xl font-black uppercase">Quem reportou dia a dia</h3>
      </div>
      <p className="text-sm text-[#A3A3A3]">
        A partir de agora, reportar a atividade dia a dia dentro da semana conta como reporte feito.
        Este botão aplica a mesma regra às semanas já passadas: tira o −10 de «sem reporte», devolve os
        pontos e retira da exclusão quem só estava excluído por isso. Primeiro só mostra o que mudaria.
      </p>
      <button onClick={() => run(false)} disabled={busy} className="kw-btn-secondary text-xs inline-flex items-center gap-2"
        data-testid="daily-fix-check"><Search className="w-4 h-4" /> Verificar</button>
      {r && (
        <div className="text-sm space-y-2" data-testid="daily-fix-report">
          {r.count === 0 && <div className="text-[#22C55E] flex items-center gap-2"><Check className="w-4 h-4" /> Não há semanas por corrigir.</div>}
          {r.count > 0 && (
            <div>
              <div>• <b>{r.count}</b> semana(s) passam a contar como reportadas:</div>
              {r.changes.map((c, i) => (
                <div key={i} className="text-[#A3A3A3] pl-3" data-testid={`daily-fix-row-${i}`}>
                  {c.name} · S{c.week} · {c.days} dia(s) reportados · {Math.round(c.points_before)} → <b className="text-white">{Math.round(c.points_after)}</b> pts
                </div>
              ))}
            </div>
          )}
          {r.applied && <div className="text-[#22C55E]">Aplicado.</div>}
          {r.count > 0 && !r.applied && (
            <button onClick={() => run(true)} disabled={busy} className="kw-btn-primary text-xs"
              data-testid="daily-fix-apply">Aplicar a {r.count} semana(s)</button>
          )}
        </div>
      )}
    </div>
  );
}
